{
  "Accessibility Menu": "Меню специальных возможностей",
  "Reset settings": "Сброс настроек",
  "Close": "Закрыть",
  "Content Adjustments": "Корректировка контента",
  "Adjust Font Size": "Настройка размера шрифта",
  "Highlight Title": "Выделить заголовки",
  "Highlight Links": "Выделить ссылки",
  "Readable Font": "Читаемый шрифт",
  "Color Adjustments": "Коррекция цвета",
  "Dark Contrast": "Темный контраст",
  "Light Contrast": "Светлый контраст",
  "High Contrast": "Высокий контраст",
  "High Saturation": "Высокая насыщенность",
  "Low Saturation": "Низкая насыщенность",
  "Monochrome": "Монохромный цвет",
  "Contrast": "Контраст",
  "Invert Colors": "Инвертировать цвета",
  "Tools": "Инструменты",
  "Reading Guide": "Руководство по чтению",
  "Stop Animations": "Остановить анимацию",
  "Big Cursor": "Большой курсор",
  "Increase Font Size": "Увеличить размер шрифта",
  "Decrease Font Size": "Уменьшить размер шрифта",
  "Letter Spacing": "Межбуквенное расстояние",
  "Line Height": "Высота линии",
  "Font Weight": "Вес шрифта",
  "Dyslexia Font": "Шрифт Дислексия",
  "Language": "Язык",
  "Open Accessibility Menu": "Открыть меню специальных возможностей",
  "Widget Settings": "Настройки виджета",
  "Widget Position": "Положение виджета",
  "Top Left": "Сверху слева",
  "Top Center": "Сверху по центру",
  "Top Right": "Сверху справа",
  "Center Left": "По центру слева",
  "Center Right": "По центру справа",
  "Bottom Left": "Снизу слева",
  "Bottom Center": "Снизу по центру",
  "Bottom Right": "Снизу справа",
  "Screen Reader": "Читатель экрана",
  "Voice Navigation": "Голосовая навигация",
  "Custom Color": "Пользовательский цвет",
  "Change the site's colors": "Изменить цвета сайта",
  "Backgrounds": "Фоны",
  "Headings": "Заголовки",
  "Contents": "Содержимое",
  "Reset colors": "Сбросить цвета",
  "Image Desaturation": "Обесцвечивание изображения",
  "Search languages": "Поиск языков",
  "No languages found": "Языки не найдены",
  "Accessibility Profiles": "Профили доступности",
  "Motor Impaired": "Нарушение моторики",
  "Big cursor, voice navigation, and no animations.": "Крупный курсор, голосовая навигация и без анимации.",
  "Blind": "Незрячие",
  "Screen reader helpers with higher contrast.": "Помощники экранного диктора с повышенным контрастом.",
  "Color Blind": "Дальтонизм",
  "High contrast palette with desaturated media.": "Палитра с высоким контрастом и приглушёнными цветами.",
  "Dyslexia": "Дислексия",
  "Friendly font, extra spacing, stronger weight.": "Удобный шрифт, больше интервала и более жирное начертание.",
  "Low vision": "Слабовидящие",
  "Dark contrast and 130% magnification.": "Тёмный контраст и увеличение 130 %.",
  "Cognitive & Learning": "Когнитивное и обучение",
  "Highlights key sections and enables voice help.": "Выделяет важные разделы и включает голосовую помощь.",
  "Seizure & Epileptic": "Припадки и эпилепсия",
  "Stops animations and desaturates imagery.": "Останавливает анимации и снижает насыщенность изображений.",
  "ADHD": "СДВГ",
  "Reading guide, highlighted links, calmer palette.": "Путеводитель для чтения, выделенные ссылки и спокойная палитра.",
  "Widget Size": "Размер виджета",
  "Default": "По умолчанию",
  "Medium": "Средний",
  "Small": "Маленький",
  "Color Blindness": "Дальтонизм",
  "Protanopia": "Протанопия",
  "Deuteranopia": "Дейтеранопия",
  "Tritanopia": "Тританопия",
  "Achromatopsia": "Ахроматопсия",
  "Simulates and assists users with color vision deficiencies.": "Имитирует и помогает пользователям с нарушениями цветового зрения."
}
